export const BANKSLIP_PAYMENT_FR_FR = {
	// Barcode input step
	infoTitle: "Information",
	barcodeInfo:
		"Jusqu'à 12 bulletins de dépôt (de paiement) seront acceptés avec une valeur minimale de R$ 10,00 qui seront déduits du solde disponible.",
	barcodeLabel: "Code-barres",
	barcodePlaceholder: "Entrez ou collez le code du bulletin ici",
	invalidBarcode: "Code-barres invalide. Veuillez vérifier et réessayer.",
	pasteCode: "Coller le code",
	stepBarcode: "Code-barres",
	stepValue: "Valeur du bulletin",
	stepReview: "Révision",

	// Payment amount section (Step 1)
	paymentAmountQuestion: "Combien voulez-vous payer ?",
	suggestedAmountMessage: "Le montant suggéré pour ce bulletin est de {{amount}}",
	paymentAmountLabel: "Montant du paiement",

	// Review step tabs
	tabValues: "Valeur du bulletin",
	tabInfo: "Révision des données",

	// Review step - Values
	valuesReview: "Révision des Valeurs",
	bankSlipValue: "Valeur du bulletin",
	anticipationFee: "Amende et intérêts",
	discounts: "Remises",
	totalToPay: "Valeur totale à payer",

	// Review step - Info
	bankSlipInfo: "Informations du Bulletin",
	beneficiary: "Bénéficiaire",
	recipientTaxId: "Identifiant fiscal du bénéficiaire",
	barCode: "Numéro du code",
	dueDate: "Échéance",
	bank: "Banque",

	// Alerts
	inactiveBankslipTitle: "Bulletin inactif",
	inactiveBankslipMessage:
		"Ce bulletin a déjà été payé ou un problème est survenu lors de son émission. Veuillez vérifier le code et réessayer.",
	expiredBankslipMessage:
		"Ce bulletin est expiré et ne peut plus être payé. Veuillez vérifier le code et réessayer.",
	missingRecipientTitle: "Données du bénéficiaire indisponibles",
	missingRecipientMessage:
		"Impossible d'identifier les données du bénéficiaire (nom et identifiant fiscal). Veuillez vérifier le bulletin et réessayer.",
	insufficientBalance: "Solde insuffisant",
	insufficientBalanceDescription:
		"Solde disponible insuffisant pour effectuer le paiement.",
	scheduledWarningTitle: "Le paiement sera programmé pour le prochain jour ouvrable",
	scheduledWarningMessage:
		"Comme cette demande est effectuée après 15h, le bulletin sera payé le prochain jour ouvrable, déjà avec le montant mis à jour.",

	// Status modal - Success
	successTitle: "Tout est prêt!",
	successDescription:
		"Le bulletin sera envoyé pour traitement par le département Financier.",
	conclude: "Terminer",
	close: "Fermer",

	// Status modal - Error
	errorTitle: "Impossible de compléter la demande",
	errorDescription:
		"Un problème est survenu lors de la tentative de réalisation de la demande.",
	goBack: "Retour",
	tryAgain: "Réessayer",

	// Actions
	continue: "Suivant",
	confirmRequest: "Confirmer la demande",

	// Loading
	processingPayment: "Traitement du paiement...",

	// Amount validation
	amountBelowMinimum: "Le montant saisi est inférieur au minimum autorisé.",

	// Generic error
	genericError: "Une erreur s'est produite. Veuillez réessayer.",
};
